import axios from "axios";

import { paymentMethodsApiPrefix } from "../../paths";
import {
  GetPaymentMethodRequest,
  GetPaymentMethodResponse,
  IApiConfig,
  NETWORK_CALL_FAILED,
  Payment,
} from "@hopper-b2b/types";
import { trackEvent } from "@hopper-b2b/api";

const END_POINT = `${paymentMethodsApiPrefix}/get`;

export const fetchPaymentMethod = (
  req: GetPaymentMethodRequest,
  apiConfig?: IApiConfig
): Promise<GetPaymentMethodResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(END_POINT, req);

      const responseBody: GetPaymentMethodResponse = res.data;
      resolve(responseBody);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });

export type IListPaymentMethodsResponse = Array<Payment>;
